/* eslint-disable no-undef */
export const getCookiesList = () => {
  const storage = typeof window !== 'undefined' && window.localStorage;

  try {
    const categorization = JSON.parse(storage && storage.getItem('categorization') || {});
    const activeGroups = OnetrustActiveGroups.split(',').filter(el => el != null);
    const cookiesList = [];

    activeGroups.forEach((group) => {
      if (categorization[group] && categorization[group].length) {
        categorization[group].forEach(cookie => cookiesList.push(cookie));
      }
    });

    return cookiesList;
  } catch (e) {
    return [];
  }
};

export const isCookieAllowed = (cookieName) => {
  const cookiesList = getCookiesList();
  return cookiesList.includes(cookieName);
};

export const registerConsentChangedCallback = (callback) => {
  if (typeof window !== 'undefined' && window.OneTrust && typeof window.OneTrust.OnConsentChanged === 'function') {
    window.OneTrust.OnConsentChanged(callback);
  }
};
